__turbopack_context__.v({
  "color": "ColorPalette-module__YgRdga__color",
  "grid": "ColorPalette-module__YgRdga__grid",
  "hex": "ColorPalette-module__YgRdga__hex",
  "info": "ColorPalette-module__YgRdga__info",
  "name": "ColorPalette-module__YgRdga__name",
  "palette": "ColorPalette-module__YgRdga__palette",
  "proportionsChart": "ColorPalette-module__YgRdga__proportionsChart",
  "proportionsImage": "ColorPalette-module__YgRdga__proportionsImage",
  "proportionsSection": "ColorPalette-module__YgRdga__proportionsSection",
  "proportionsText": "ColorPalette-module__YgRdga__proportionsText",
  "row": "ColorPalette-module__YgRdga__row",
  "section": "ColorPalette-module__YgRdga__section",
  "sectionTitle": "ColorPalette-module__YgRdga__sectionTitle",
  "small": "ColorPalette-module__YgRdga__small",
  "swatch": "ColorPalette-module__YgRdga__swatch",
  "value": "ColorPalette-module__YgRdga__value",
});
